<template>
  <div class='knd-story'>
    <!-- <AnimationLine /> -->
  <div class=''>
  <div 
    class="bg-image"
    :style="{'background-image': `url(${ASSETS}${data.background.data.attributes.url})`}"
  >
  </div>
    <KndHeader />
      
      <div class="knd-phone-starter">
        <!-- <Rope /> -->
        <KndIntro />
        <ScrollyZoom />
      </div>
        <!-- <ScrollyScroll /> -->

        <kndOutro />
      
    </div>

    <ModalSync />
  </div>
</template>

<script>
import './scss/index.scss'

import KndHeader from './story/header';
import KndIntro from './story/intro';
import kndOutro from './story/outro';
import ScrollyZoom from './story/scrolly-zoom';
import ModalSync from './story/modal-sync';


import AnimationLine from './story/lines';

// import kndOptions from './story/options';
// import Animation from './story/animation';
import Rope from './story/rope';


import { computed, ref } from 'vue';
import { useStore } from 'vuex';

export default {
	components: {KndHeader, KndIntro, Rope, kndOutro, ScrollyZoom, ModalSync, AnimationLine},
  setup () {
    const store = useStore()
    const ASSETS = ref(process.env.VUE_APP_ASSETS);

    return {
      data: computed(() => store.getters.data),
      ASSETS
    }
  }
}
</script>

<style lang="scss">
  .knd-story {

  }

.knd-phone-starter {
  position: relative;
}

</style>